import React, { useEffect } from "react"
import Navbar from "./Navbar";
import Footer from "./Footer";
import FollowUsAndScrollToTop from "./FollowUsAndScrollToTop";
import '../../static/styles/global.css';
import TawkToScript from "./TawkToScript";
import { useLocation } from '@reach/router';
import $ from 'jquery';
// import OfferPopup from "./OfferPopup";

export default function Layout({ children }) {

    const location = useLocation();

    useEffect(() => {
        if($('body').hasClass('navbar-collapse-show')) {
            $('body').removeClass('navbar-collapse-show');
            $('html').removeClass('overflow-hidden');
        }
    }, [location]);

    return (
        <React.Fragment>

            <Navbar />

            {children}

            <Footer />

            <FollowUsAndScrollToTop />

            <TawkToScript />

            {/*<OfferPopup />*/}

        </React.Fragment>
    );

}
